var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TextAreaWidget as _TextAreaWidget } from '../angular2-schema-form-shim';
import { isWidgetRequired } from './overrides';
var TextAreaWidget = (function (_super) {
    __extends(TextAreaWidget, _super);
    function TextAreaWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TextAreaWidget.prototype, "required", {
        get: function () {
            return isWidgetRequired(this);
        },
        enumerable: true,
        configurable: true
    });
    return TextAreaWidget;
}(_TextAreaWidget));
export { TextAreaWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/textarea.widget.ts.pre-build-optimizer.js